
      import PlusCircle from './plus-circle.vue'
      import type { App, Plugin } from 'vue'

      export const PlusCirclePlugin: Plugin = {
        install(app: App) {
          app.component('PlusCircle', PlusCircle)
        },
      }
      export { PlusCircle }
      